document.addEventListener("DOMContentLoaded", () => {
  const section = document.querySelector(".service-hero");
  if (!section) return;

  const buttons = section.querySelectorAll(".service-hero__navigation-button");
  const images = section.querySelectorAll(".service-hero__left-img");
  const containers = section.querySelectorAll(".service-hero__container");

  buttons.forEach((btn, idx) => {
    btn.addEventListener("click", () => {
      // Remove active class from all buttons, images, and containers
      buttons.forEach((b) => b.classList.remove("active"));
      images.forEach((i) => i.classList.remove("active"));
      containers.forEach((c) => c.classList.remove("active"));

      // Add active class to the clicked button, corresponding image, and container
      btn.classList.add("active");
      images[idx]?.classList.add("active");
      containers[idx]?.classList.add("active");
    });
  });
});
